import { parseApiError } from '../../api/request';
import { captureException as captureLogRocketException, initializeLogRocket } from '../logrocket';
import {
    captureException as captureSentryException,
    initializeSentry,
    withScope as withSentryScope,
} from '../sentry';

export const initializeErrorTracking = (sentryDsn: string, logRocketDsn: string) => {
    const env = config.env;

    initializeSentry(env, sentryDsn);
    initializeLogRocket(logRocketDsn);
};

export const captureException = (error) => {
    // Do not capture errors in local environment
    if (config.env === 'local') {
        return null;
    }

    const apiError = parseApiError(error);

    captureSentryException(error, { tags: { api: true, code: apiError.code } });
    captureLogRocketException(error, { tags: { api: true, code: apiError.code } });
};

export const captureUnhandledError = (error, info, callback: (id: string) => void) => {
    // Do not capture errors in local environment
    if (config.env === 'local') {
        return null;
    }

    withSentryScope((scope) => {
        scope.setExtras(info);
        const eventId = captureSentryException(error);
        callback(eventId);
    });
    captureLogRocketException(error, { extra: info });
};
